export default "__VITE_ASSET__DjQocyL___"